module.exports = __webpack_public_path__ + "static/media/0014.90badd33.jpg";